<section class="py-3">
  <div class="container-fluid card card-div">

    <div class="row d-flex justify-content-between align-items-center g-3 mb-4 sticky-header flex-shrink-0">
      <div class="col-12 col-md-8 sku-ledger-widget d-flex flex-column align-items-start">
        @if (isCreateMode) {
          <button class="btn btn-back mb-2" (click)="toggleCreateMode(false)">
            <fa-icon [icon]="faArrowLeft" class="me-1"></fa-icon> Back
          </button>
        }
        <div class="sku-badge px-3 px-md-4 py-2 mb-2 d-inline-block">
          <h2 class="sku-name fw-bold m-0 text-break">
            {{ isCreateMode ? 'Create New Merge' : 'Merge SKUs' }}
          </h2>
        </div>
        <span class="footer-text text-muted small">
          {{ isCreateMode ? 'Combine duplicate or split SKUs into one record. This cannot be undone.' : 'Track merges that are running and those already completed.' }}
        </span>
      </div>

      @if (!isCreateMode) {
        <div class="col-12 col-md-4 d-flex align-items-center gap-2 justify-content-md-end flex-wrap">
          <button class="btn btn-add-sku px-3 py-2" (click)="refreshList()" [disabled]="loader">
            <fa-icon [icon]="faRotate" class="me-1"></fa-icon>
            <span class="fw-bold small">Refresh</span>
          </button>
          <button class="btn app-btn-primary px-3 py-2" (click)="toggleCreateMode(true)" [disabled]="isAnyMergingInProgress || errMessage || loader">
            <fa-icon [icon]="faPlus" class="me-1"></fa-icon>
            <span class="fw-bold small">Create New Merge</span>
          </button>
        </div>
      }
    </div>

    <div class="inner-scroll" infiniteScroll [scrollWindow]="false"
         [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500" (scrolled)="onScrollList()">

    @if (!isCreateMode) {

      @if (mergeList.length) {
        <div class="merge-list-container animate-fade-in">

          @if (mergingInProgressList.length > 0) {
            <div class="card merge-section-card mb-4 bg-white">
              <div class="d-flex justify-content-between align-items-center mb-0">
                <h5 class="merge-section-title m-0">Merging in progress</h5>
                <span class="sku-counter">
                  {{ mergingInProgressList.length }} {{ mergingInProgressList.length === 1 ? 'SKU' : 'SKUs' }}
                </span>
              </div>

              <div class="d-flex flex-column gap-3">
                @for (item of mergingInProgressList; track item._id || $index) {
                  <div class="history-item-card">
                    <div class="d-flex flex-column gap-2 flex-grow-1 min-w-0">
                      <h4 class="sku-title" [title]="getTargetSkuLabel(item)">
                        {{ getTargetSkuLabel(item) }}
                      </h4>
                      <div class="sku-meta d-flex flex-wrap gap-2 align-items-center">
                        <span>Started at {{ (item.startedAt || item.created) | date:'dd MMM yyyy, hh:mm a':'Asia/Kolkata' }}</span>
                      </div>
                      <div class="sku-sources" [title]="getSourcesLabel(item)">
                        <strong>Sources:</strong> {{ getSourcesLabel(item) }}
                      </div>
                    </div>
                    
                    <div class="badge-container">
                      <span class="status-badge text-center" [ngClass]="getStatusClass(item.status)">
                        {{ getStatusLabel(item.status) }}
                      </span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          @if (mergingCompletedList.length > 0) {
            <div class="card merge-section-card mb-4 bg-white">
              <div class="d-flex justify-content-between align-items-center mb-0">
                <h5 class="merge-section-title m-0">Merging completed</h5>
                <span class="sku-counter">
                  {{ mergingCompletedList.length }} {{ mergingCompletedList.length === 1 ? 'SKU' : 'SKUs' }}
                </span>
              </div>

              <div class="d-flex flex-column gap-3">
                @for (item of mergingCompletedList; track item._id || $index) {
                  <div class="history-item-card">
                    <div class="d-flex flex-column gap-2 flex-grow-1 min-w-0">
                      <h4 class="sku-title" [title]="getTargetSkuLabel(item)">
                        {{ getTargetSkuLabel(item) }}
                      </h4>
                      <div class="sku-meta d-flex flex-wrap gap-2 align-items-center">
                        @if (getStatusLabel(item.status) === 'Failed') {
                          <span>Failed at {{ (item.completedAt || item.updated || item.created) | date:'dd MMM yyyy, hh:mm a':'Asia/Kolkata' }}</span>
                        } @else {
                          <span>Completed at {{ (item.completedAt || item.updated || item.created) | date:'dd MMM yyyy, hh:mm a':'Asia/Kolkata' }}</span>
                          <span class="meta-dot">·</span>
                          <span>Record updated</span>
                        }
                      </div>
                      <div class="sku-sources" [title]="getSourcesLabel(item)">
                        <strong>Sources:</strong> {{ getSourcesLabel(item) }}
                      </div>
                    </div>
                    
                    <div class="badge-container">
                      <span class="status-badge text-center" [ngClass]="getStatusClass(item.status)">
                        {{ getStatusLabel(item.status) }}
                      </span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }

      @if (loader) {
      <div class="d-flex justify-content-center my-3">
        <app-loader [loadingIcon]="loader"></app-loader>
      </div>
      }
      
      @if (!loader && errMessage) {
      <div class="alert alert-warning d-flex justify-content-center align-items-center my-3 mx-1">
        <span>{{ errMessage }}</span>
      </div>
      }
      
      @if (!loader && !errMessage && mergeList.length == 0) {
      <div class="empty-card p-5 text-center rounded-4 text-muted bg-white">
        No merge records found. Click "Create New Merge" to combine SKUs.
      </div>
      }

    }  @else {

      <div class="create-merge-container animate-fade-in">
        
        <!-- Add SKU Card -->
        <div class="card add-sku-card mb-4 bg-white">
          <h5 class="add-sku-title mb-3">Add SKU</h5>
          
          <div class="row g-3">
            <!-- Dropdown 1: Tyre Size -->
            <div class="col-12 col-md-4">
              <label for="tyreSizeSelect" class="custom-label">Tyre size</label>
              <div class="position-relative search-select-wrapper">
                <ng-select labelForId="tyreSizeSelect" [items]="tyreSizeList" bindLabel="tyreSize" bindValue="tyreSize"
                  [multiple]="false" [clearable]="true" [searchable]="true"
                  placeholder="Search tyre size..." [(ngModel)]="selectedTireSize"
                  class="custom-search-select" (scrollToEnd)="scrollTyreSize()"
                  (search)="onTyreSizeInputChange($event)" [searchFn]="customSearchFn"
                  [disabled]="addedSkusList.length > 0" appendTo="body"
                  (close)="onSizeClose()" (clear)="onSizeClose()">
                </ng-select>
              </div>
            </div>

            <!-- Dropdown 2: Brand (Make) -->
            <div class="col-12 col-md-4">
              <label for="brandSelect" class="custom-label">Brand</label>
              <div class="position-relative search-select-wrapper">
                <ng-select labelForId="brandSelect" [items]="tyreMakeList" bindLabel="item" bindValue="item"
                  [multiple]="false" [clearable]="true" [searchable]="true"
                  placeholder="Search brand..." [(ngModel)]="selectedBrand"
                  (change)="onMakeSelected()" class="custom-search-select"
                  (search)="onTyreMakeInputChange($event)" [searchFn]="customSearchFn"
                  [disabled]="addedSkusList.length > 0" appendTo="body"
                  (close)="onMakeClose()" (clear)="onMakeClose()">
                </ng-select>
              </div>
            </div>

            <!-- Dropdown 3: Pattern (Model) -->
            <div class="col-12 col-md-4">
              <label for="patternSelect" class="custom-label">Pattern</label>
              <div class="position-relative search-select-wrapper">
                <ng-select labelForId="patternSelect" [items]="filteredModelList" bindLabel="name" bindValue="name"
                  [multiple]="false" [clearable]="true" [searchable]="true"
                  placeholder="Search pattern..." [(ngModel)]="selectedPattern"
                  class="custom-search-select" (scrollToEnd)="scrollTyreModel()"
                  (search)="onTyreModelInputChange($event)" [searchFn]="customSearchFn"
                  [disabled]="!selectedBrand" appendTo="body"
                  (close)="onModelClose()" (clear)="onModelClose()">
                </ng-select>
              </div>
            </div>
          </div>

          <!-- Add Another SKU Link -->
          @if (selectedTireSize && selectedBrand && selectedPattern) {
            <div class="mt-3 text-end">
              <button class="btn btn-link btn-add-sku" (click)="addSkuToList()">
                Add To List
              </button>
            </div>
          }
        </div>

        <!-- SKUs to Merge List -->
        <div class="card skus-to-merge-card mb-4 bg-white">
          <div class="d-flex justify-content-between align-items-center mb-0">
            <h5 class="skus-to-merge-title m-0">SKUs To Merge</h5>
            <span class="text-muted small fw-semibold">
              {{ addedSkusList.length }} {{ addedSkusList.length === 1 ? 'SKU' : 'SKUs' }}
            </span>
          </div>

          @if (addedSkusList.length === 0) {
            <div class="p-5 text-center text-muted">
              Select tyre size, brand, and pattern above. The SKU will appear here.
            </div>
          } @else {
            <div class="d-flex flex-column gap-3">
              @for (item of addedSkusList; track item._id || $index; let i = $index) {
                <div class="merge-queue-item-card">
                  <div class="d-flex flex-column gap-1 flex-grow-1 min-w-0">
                    <h4 class="sku-title m-0">
                      {{ item.size }} {{ item.make }} {{ item.model }}
                    </h4>
                    <span class="sku-meta">
                      {{ item.size }} · {{ item.make }} · {{ item.model }}
                    </span>
                  </div>
                  
                  <button class="btn p-2" (click)="removeSkuFromList(i)" title="Remove from list">
                    <fa-icon [icon]="faTrash" class="text-danger"></fa-icon>
                  </button>
                </div>
              }
            </div>
          }
        </div>

        <!-- Bottom Actions & Info Panel -->
        <div class="d-flex flex-column align-items-end mt-4 w-100">
          @if (addedSkusList.length < 2) {
            <span class="text-muted-gray mb-2">
              {{ addedSkusList.length === 0 ? 'Add at least 2 SKUs to merge' : 'Add one more SKU to merge.' }}
            </span>
          } @else {
            <div class="bottom-msg-card mb-3">
              <span>{{ addedSkusList.length }} SKUs will be combined into 1.</span>
            </div>
          }
          <button class="btn app-btn-primary merge-skus-btn d-flex align-items-center gap-2" 
            [disabled]="addedSkusList.length < 2"
            (click)="openMergeConfirmModal(mergeConfirmModal)">
            <span>Merge SKUs</span>
          </button>
        </div>

      </div>
    }
    </div>
  </div>
</section>

<ng-template #mergeConfirmModal let-modal>
  <div class="modal-content border-0 rounded-4">
    
    <div class="modal-header border-0 pb-1">
      <div class="d-flex flex-column">
        <h4 class="modal-title fw-bold text-dark mb-1">Merge SKUs</h4>
        <span class="modal-subtitle">Review details before combining into one SKU.</span>
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()" [disabled]="saveLoader"></button>
    </div>

    <div class="modal-body py-3">
      
      <div class="alert alert-orange mb-3 rounded-3 d-flex flex-column">
        <span class="alert-title mb-1">This cannot be undone</span>
        <span class="alert-desc">
          All sales, sale records, purchase records, stock movements, and ledger history for the selected SKUs will be combined into a single SKU record. You cannot split or restore them after merging.
        </span>
      </div>

      <div class="mb-3 d-flex flex-column">
        <span class="merge-list-title mb-2">These SKUs will be merged</span>
        <div class="merge-list-card rounded-3">
          <ul class="list-unstyled m-0 d-flex flex-column gap-2">
            @for (item of addedSkusList; track item._id || $index) {
              <li>• {{ item.size }} {{ item.make }} {{ item.model }}</li>
            }
          </ul>
        </div>
      </div>

      <div class="mb-3">
        <label for="finalSkuSelect" class="merge-list-title mb-2 d-block">Final SKU name <span class="text-danger">*</span></label>
        <div class="position-relative search-select-wrapper">
          <ng-select labelForId="finalSkuSelect" [items]="addedSkusList" bindLabel="label" bindValue="model"
            [multiple]="false" [clearable]="false" [searchable]="false"
            placeholder="Select final SKU name..." [(ngModel)]="selectedTargetModel"
            class="custom-search-select" [disabled]="saveLoader">
          </ng-select>
        </div>
        <span class="final-sku-help mt-1 d-block">
          Name for the single SKU record after the merge. Edit if you want a different label.
        </span>
      </div>

      <div class="mb-3">
        <label for="mergeReasonInput" class="merge-list-title mb-2 d-block">Reason <span class="text-danger">*</span></label>
        <input id="mergeReasonInput" type="text" class="form-control" placeholder="Enter reason for merge..." [(ngModel)]="mergeReason" [disabled]="saveLoader">
      </div>

      <div class="form-check mb-3 d-flex align-items-center gap-2">
        <input class="form-check-input cursor-pointer" type="checkbox" id="permanentConfirm" [(ngModel)]="isPermanentConfirmed" [disabled]="saveLoader">
        <label class="form-check-label cursor-pointer m-0 text-dark" for="permanentConfirm">
          I understand this merge is permanent and cannot be undone.
        </label>
      </div>

      @if (saveErrMessage) {
        <div class="alert alert-danger py-2 px-3 small rounded-3 mt-2 mb-0">
          {{ saveErrMessage }}
        </div>
      }
    </div>

    <div class="modal-footer border-0 pt-0 pb-4 d-flex flex-column gap-2 px-3">
      <button class="btn app-btn-primary w-100 d-flex align-items-center justify-content-center gap-2" 
        (click)="submitMerge()" 
        [disabled]="!isPermanentConfirmed || !mergeReason.trim() || saveLoader">
        <span>Merge SKUs</span>
        @if (saveLoader) {
          <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
        }
      </button>
      
      <button class="btn btn-outline-secondary w-100" 
        (click)="modal.dismiss()" 
        [disabled]="saveLoader">
        Cancel
      </button>
    </div>

  </div>
</ng-template>

@if (toasterMsg) {
  <app-toaster [title]="toasterMsg" (closeToaster)="toasterMsg = ''"></app-toaster>
}
